export default __webpack_public_path__ + "static/header-title-do-dark-3b15a86f3962f13ffe5e6fbe21a6f0abf26db339466a3c41204377ef0281a671.png";